import React, { useEffect, useState } from 'react';
import BgImg from '../assets/images/analytics-shape-bg.png';
import { Select } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { downloadTestimonialDataService, downloadWebinarDataService } from '../services/apiServices';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Fragment } from 'react';
import MetaDecorators from '../components/MetaDecorators';

const { Option } = Select;

function AnalyticsLanding() {
  const { domainDetails, status } = useSelector((state) => state.listings);
  const [dataFor, setDataFor] = useState('');
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(false);

  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    const header = document.getElementById('header');
    const footer = document.getElementById('footer');
    const body = document.querySelector('body');
    if (header !== null) {
      header.style.display = 'none';
    }
    if (footer !== null) {
      footer.style.display = 'none';
    }
    if (body !== null) {
      body.style.paddingBottom = '0px';
    }

    return () => {
      if (header !== null) {
        header.style.display = 'unset';
      }
      if (footer !== null) {
        footer.style.display = 'unset';
      }
    };
  }, []);

  useEffect(() => {
    if (domainDetails && domainDetails.id && domainDetails.orgType === 'certifier') {
      history.push('/');
    }
  }, [domainDetails]);

  const handleChange = (value) => {
    if (value !== '') {
      setDataFor(value);
      setError(false);
    }
  };

  const handleDownload = () => {
    if (dataFor === '') {
      setError(true);
    } else {
      if (domainDetails && domainDetails.id && domainDetails.orgType === 'industry_partner') {
        if (dataFor === 'testimonial') {
          downloadFileRequest(downloadTestimonialDataService);
        } else if (dataFor === 'webinar') downloadFileRequest(downloadWebinarDataService);
      }
    }
  };

  const downloadFileRequest = (service) => {
    setDownloading(true);
    const accessToken = localStorage.getItem('userAccessToken');
    service(domainDetails.id, accessToken)
      .then((response) => {
        downloadFileFromResponse(response, `${dataFor}_${getFormattedTime()}.xlsx`);
      })
      .catch((error) => {
        console.error(error);
        setDownloading(false);
      });
  };

  const downloadFileFromResponse = (data, fileName) => {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    Swal.fire({
      type: 'success',
      title: 'File has been successfully downloaded!',
      confirmButtonText: 'OK',
      confirmButtonColor: '#0081d4',
    });
    setDownloading(false);
    setDataFor('');
  };

  const getFormattedTime = () => {
    var today = new Date();
    var y = today.getFullYear();
    var m = today.getMonth() + 1;
    var d = today.getDate();
    var h = today.getHours();
    var mi = today.getMinutes();
    var s = today.getSeconds();
    return y + '-' + m + '-' + d + '-' + h + '-' + mi + '-' + s;
  };

  return (
    <div className='analyticsWrapper'>
      <MetaDecorators />
      <div className='analyticsLeftSection'>
        <img src={BgImg} alt='bg' className='rectangleBox' />
        <div className='analyticsLeftSectionContent'>
          {domainDetails && (
            <Fragment>
              <div className='orgLogo'>
                <img src={domainDetails.image} alt={domainDetails.domainName} />
              </div>
              <h3 className='orgNameAnalytics'>{domainDetails.name}</h3>
            </Fragment>
          )}
          <h2>Data Available</h2>
          <ul className='productList'>
            <li onClick={() => setDataFor('testimonial')}>Testimonial Data Download</li>
            <li onClick={() => setDataFor('webinar')}>Webinar Data Download</li>
          </ul>
        </div>
      </div>
      <div className='analyticsRightSection'>
        <div className='analyticsRightSectionContent'>
          <h1>Download Data</h1>
          <label>Select to download</label>
          <Select
            showSearch
            placeholder='Select to download'
            optionFilterProp='children'
            size='large'
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
            value={dataFor || undefined}
            onChange={handleChange}
            className={error ? 'fieldError' : ''}
            virtual={false}
          >
            <Option value='testimonial'>Testimonial Data</Option>
            <Option value='webinar'>Webinar Data</Option>
          </Select>
          <button className='downloadButton' disabled={downloading ? 'disabled' : ''} onClick={handleDownload}>
            {downloading ? (
              'Please wait...'
            ) : (
              <Fragment>
                Download
                <DownloadOutlined />
              </Fragment>
            )}
          </button>
        </div>
        <p className='analyticsVersion'>Version 1.0</p>
      </div>
    </div>
  );
}

export default AnalyticsLanding;
